import { createSelector } from 'reselect';
import get from 'lodash/get';
import { getChannelForWidget } from '../../common/selectors/channels';


const getSelectedVideoIdFromStore = state => state.selectedVideoId;
const getFeaturedVideoId = createSelector([getChannelForWidget], channel => get(channel, 'featuredItem'));
const getFirstVideoFromList = (state, listType) => (get(state.lazyVideoLists[listType], 'idChunks[0][0]') || get(state.lazyVideoLists[listType], 'videoIds[0]'));

export const getMainVideoId = createSelector(
  [getSelectedVideoIdFromStore, getFeaturedVideoId, getFirstVideoFromList],
  (selectedVideoId, featuredVideoId, firstVideoId) =>
    selectedVideoId || featuredVideoId || firstVideoId
);



// WEBPACK FOOTER //
// ./~/wix-vod-shared/src/widget/ui-selectors/selected-video-id.js